import config from "@/views/product/views/config/config";
export default config;
